<template>
    <div class="custom-page-loader" v-if="show" :class="{'is-local': isLocalLoader}">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" height="128" width="128" style="fill: var(--text-color);">
        <rect x="0" y="13" width="4" height="5">
          <animate attributeName="height" attributeType="XML" values="5;21;5" begin="0s" dur="0.6s" repeatCount="indefinite"></animate>
          <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0s" dur="0.6s" repeatCount="indefinite"></animate>
        </rect>
        <rect x="10" y="13" width="4" height="5">
          <animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate>
          <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate>
        </rect>
        <rect x="20" y="13" width="4" height="5">
          <animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate>
          <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate>
        </rect>
      </svg>
      <div v-if="loadingMessage" class="my-3">{{ $t(loadingMessage) }}</div>
      <Button v-if="cancel" @click="$emit('cancelEvent')" :label="$t('Cancel')" class="mt-3" severity="danger" />
    </div>
</template>

<script>
export default {
  name: "Loader",
  props: {
    isLoading: {
      type: Boolean,
      default: true
    },
    isLocalLoader: {
      type: Boolean,
      default: false
    },
    loadingMessage: {
      type: String,
      default: ''
    },
    cancel:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: this.isLoading
    }
  },
  mounted() {
    this.setLoader(this.show);
  },
  methods: {
    setLoader(loading) {
      if (loading) {
        this.show = true;
        this.$nextTick(() => {
          const pageLoaders = document.querySelectorAll('.custom-page-loader');
          if (pageLoaders.length > 1) {
            for (let i = 1; i < pageLoaders.length; i++) {
              pageLoaders.item(i).style.opacity = 0;
            }
          }
          if (pageLoaders[0]) pageLoaders[0].style.opacity = 1;
        })
      } else {
        const pageLoaders = document.querySelectorAll('.custom-page-loader');
        if (pageLoaders[0]) pageLoaders[0].style.opacity = 0;
        setTimeout(() => {
          this.show = false;
        }, 100);
      }
    }
  },
  watch: {
    isLoading(newVal) {
      this.setLoader(newVal)
    }
  }
}
</script>

<style scoped lang="scss">
.custom-page-loader {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000000;
  background: var(--maskbg);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity .1s;

  svg {
    width: 80px;
    height: auto;
  }

  &.is-local {
    position: absolute;
    svg {
      width: 40px;
      height: auto;
    }
  }
}
</style>
